// @flow

import {fromJS} from 'immutable';

import type {RawRecurrentFolderType, RawFolderType} from './types';
import {
  REQUEST_FOLDERS_DASHBOARDS_LIST,
  RECEIVE_FOLDERS_DASHBOARDS_LIST,
  type FolderActionType,
  RECEIVE_FOLDER_DETAILS,
} from './actions';

import {setNormalizedList} from 'app/utils/redux_v2';

const initialState = {
  // v2 reducers
  byId: {},
  queries: {},
  dashboard: {
    currentFilters: {},
  },
};

export function folders(
  state: any = fromJS(initialState),
  action: FolderActionType
): any {
  switch (action.type) {
    case REQUEST_FOLDERS_DASHBOARDS_LIST:
      return state
        .setIn(['dashboard', 'currentFilters'], fromJS(action.currentFilters))
        .set('isFetching', true);

    case RECEIVE_FOLDERS_DASHBOARDS_LIST: {
      return setNormalizedList(
        action.query,
        action.response,
        state,
        (folder) => folder.hashid
      ).set('isFetching', false);
    }
    case RECEIVE_FOLDER_DETAILS: {
      const byId = unwrapFolders(action.item);
      return state.mergeIn(['byId'], fromJS(byId));
    }
    default:
      return state;
  }
}

function unwrapFolders(folder: RawRecurrentFolderType): {
  [string]: RawFolderType,
} {
  let folders = {};
  let currentFolder = folder;

  while (currentFolder != null) {
    const parent = currentFolder.parent;

    folders[currentFolder.hashid] = {
      ...currentFolder,
      parent: parent != null ? parent.hashid : null,
    };
    currentFolder = parent;
  }
  return folders;
}
